(function () {
  function initSiteMenu() {
    var toggle = document.querySelector("[data-ll-menu-toggle]");
    var menu = document.querySelector("[data-ll-site-menu]");
    if (!toggle || !menu) return;
    if (menu.dataset.llMenuReady === "true") return;
    menu.dataset.llMenuReady = "true";

    var closeButtons = menu.querySelectorAll("[data-ll-menu-close]");
    var links = menu.querySelectorAll("a");
    var groups = menu.querySelectorAll("details.ll-site-menu__group");

    function collapseGroups() {
      groups.forEach(function (group) {
        group.removeAttribute("open");
      });
    }

    function openMenu() {
      menu.hidden = false;
      document.documentElement.classList.add("ll-menu-open");
      document.body.classList.add("ll-menu-open");
      toggle.setAttribute("aria-expanded", "true");
    }

    function closeMenu() {
      menu.hidden = true;
      document.documentElement.classList.remove("ll-menu-open");
      document.body.classList.remove("ll-menu-open");
      toggle.setAttribute("aria-expanded", "false");
      collapseGroups();
    }

    toggle.addEventListener("click", function () {
      if (menu.hidden) {
        openMenu();
      } else {
        closeMenu();
      }
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeMenu);
    });

    links.forEach(function (link) {
      link.addEventListener("click", closeMenu);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !menu.hidden) {
        closeMenu();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", initSiteMenu);
  document.addEventListener("shopify:section:load", initSiteMenu);

  // Keep the header bag count in sync for cart updates that don't open the
  // drawer (e.g. the school bulk-order and quick-order quantity tables). These
  // flows publish a cartUpdate with the full cart payload, so we update the
  // badge silently without revealing the drawer.
  function updateHeaderCartCount(itemCount) {
    var countEl = document.getElementById("cart-notification-count");
    if (!countEl) return;
    countEl.textContent = itemCount;
    countEl.classList.toggle("hidden", Number(itemCount) === 0);
  }

  function refreshHeaderCartCount() {
    var cartUrl =
      window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart";
    fetch(cartUrl + ".js", { headers: { Accept: "application/json" } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateHeaderCartCount(cart && cart.item_count ? cart.item_count : 0);
      })
      .catch(function () {});
  }

  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined" &&
    PUB_SUB_EVENTS.cartUpdate
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cartData = event && event.cartData;
      // Bulk/quick-order flows send the full cart (has item_count); use it.
      // product-form sends the /cart/add.js line response (no item_count) and
      // only swaps the number inside the badge, so fetch the truth to also
      // correct the hidden state on the 0 -> 1 transition.
      if (cartData && typeof cartData.item_count === "number") {
        updateHeaderCartCount(cartData.item_count);
      } else {
        refreshHeaderCartCount();
      }
    });
  }
})();
